import { userService } from 'account/user/service/userService';
import { FormInstance, message, Modal } from 'antd';
import { RolePermissionType } from 'permission/role/type/roleType';
import { NavigateFunction } from 'react-router-dom';
import { UserInterface } from '../types/userType';

interface UserEditHandlersProps {
  id: number;
  form: FormInstance;
  navigate: NavigateFunction;
}

interface UserEditHandlersReturn {
  onFinish: () => Promise<void>;
}

export const getUserEditHandlers = ({
  id,
  form,
  navigate,
}: UserEditHandlersProps): UserEditHandlersReturn => {
  const onFinish = async (): Promise<void> => {
    const loadingMessage = message.loading('Updating...', 0);
    try {
      const values = await form.validateFields();
      const user: UserInterface = {
        id: id,
        username: values.username,
        email: values.email,
        first_name: values.first_name,
        last_name: values.last_name,
        platform: values.platform,
      };

      if (values.company?.id) {
        user.company = values.company;
      }
      await userService.updateUserWithRole(
        id,
        user,
        values.roles.map((role: RolePermissionType) => role.id)
      );
      loadingMessage();
      navigate('/user', {
        state: {
          message: 'User information has been updated successfully',
          userId: id,
        },
      });
    } catch (error) {
      loadingMessage();
      Modal.error({
        title: 'Error',
        content: 'Failed to update : ' + error,
        okText: 'Confirm',
      });
    }
  };

  return {
    onFinish,
  };
};
